const NUMBER_OF_TRIES = 20;
const TRIES_INTERVAL = 200;
let INTERVAL_TRIES = 0;
let UPSELL_TITLE;

document.addEventListener('DOMContentLoaded', () => {
    initiateCheckoutAction();
    initCouponForm();
    initCompanyFields();
    hidePeCouponRows();
    new MutationObserver(hidePeCouponRows).observe(document.body, {childList: true, subtree: true});
});

const applyCoupon = () => {
    const params = window.wc_checkout_params;
    if (!params) return;

    const couponDiv = document.querySelector('.checkout_coupon');
    const couponInput = document.querySelector('.checkout_coupon #coupon_code');
    const couponCode = couponInput?.value?.trim();
    if (!couponCode) return;

    const url = params.wc_ajax_url.replace('%%endpoint%%', 'apply_coupon');
    const formData = new FormData();
    formData.append('coupon_code', couponCode);
    formData.append('security', params.apply_coupon_nonce);
    formData.append('billing_email', document.querySelector('input[name="billing_email"]')?.value || '');

    fetch(url, { method: 'POST', body: formData })
        .then(res => res.text())
        .then(response => {
            document.querySelectorAll('.woocommerce-error, .woocommerce-message').forEach(el => el.remove());
            if (response && !response.includes('woocommerce-error') && !response.includes('is-error')) {
                couponDiv?.insertAdjacentHTML('beforebegin', response);
                couponDiv.style.display = 'none';
                if (couponInput) couponInput.value = '';
                window.jQuery?.(document.body).trigger('update_checkout');
            } else {
                couponDiv?.insertAdjacentHTML('beforebegin', response);
            }
        });
};

const initCouponForm = () => {
    document.addEventListener('click', (e) => {
        const button = e.target.closest('.checkout_coupon [name="apply_coupon"]');
        if (!button) return;
        e.preventDefault();
        applyCoupon();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;
        if (!e.target.closest('.checkout_coupon #coupon_code')) return;
        e.preventDefault();
        e.stopPropagation();
        applyCoupon();
    });
};


const hidePeCouponRows = () => {
    document.querySelectorAll('.wc-block-components-chip__text').forEach(chip => {
        if (chip.textContent.includes('pe_cs_')) {
            if (chip?.parentNode) {
                chip.parentNode.style.display = 'none';
            }
        }
    });
};

const validateSlovenianVat = (raw) => {
    const v = raw.replace(/^SI/i, '').trim();
    if (!/^[1-9]\d{7}$/.test(v)) return false;
    const d = [...v].map(Number);
    const sum = [8, 7, 6, 5, 4, 3, 2].reduce((acc, w, i) => acc + w * d[i], 0);
    let check = 11 - (sum % 11);
    if (check >= 10) check = 0;
    return d[7] === check;
};

const syncVatFieldValidity = () => {
    const checkbox = document.querySelector('#billing_is_company');
    const vatInput = document.querySelector('#billing_company');
    if (!checkbox?.checked || !vatInput?.value) return;
    const valid = validateSlovenianVat(vatInput.value);
    vatInput.closest('.form-row')?.classList.toggle('woocommerce-invalid', !valid);
    vatInput.closest('.form-row')?.classList.toggle('woocommerce-validated', valid);
};

const initCompanyFields = () => {
    const checkbox = document.querySelector('#billing_is_company');
    if (!checkbox) return;

    const updateFields = () => {
        const on = checkbox.checked;
        document.querySelectorAll('.pe-company-field').forEach(wrapper => {
            wrapper.classList.toggle('pe-company-field--visible', on);
            wrapper.classList.toggle('validate-required', on);
            const input = wrapper.querySelector('input[type="text"]');
            if (input) {
                on ? input.setAttribute('required', 'required') : input.removeAttribute('required');
            }
            if (!on) {
                wrapper.classList.remove('woocommerce-invalid', 'woocommerce-invalid-required-field', 'woocommerce-validated');
            }
            const label = wrapper.querySelector('label');
            if (label) {
                let abbr = label.querySelector('abbr.required');
                if (on && !abbr) {
                    abbr = document.createElement('abbr');
                    abbr.className = 'required';
                    abbr.title = 'required';
                    abbr.textContent = '*';
                    label.appendChild(abbr);
                } else if (!on && abbr) {
                    abbr.remove();
                }
            }
        });
    };

    updateFields();
    checkbox.addEventListener('change', updateFields);

    const vatInput = document.querySelector('#billing_company');
    if (vatInput) {
        vatInput.addEventListener('blur', syncVatFieldValidity);
    }

    window.jQuery?.(document.body).on('checkout_error', syncVatFieldValidity);
};

const initiateCheckoutAction = () => {
    if (!document.body.classList.contains('woocommerce-checkout') ||
        document.querySelector('form.checkout.woocommerce-checkout')) {
        return;
    }

    let interval = setInterval(async () => {
        INTERVAL_TRIES++;
        if (NUMBER_OF_TRIES < INTERVAL_TRIES) {
            clearInterval(interval);
        }

        const orderAddContainer = document.querySelector('#pe-order-add');
        if (orderAddContainer) {
            clearInterval(interval);
            await upsells(orderAddContainer);
        }

    }, TRIES_INTERVAL);
}

const upsells = async (orderAddContainer) => {
    try {
        const formData = new FormData();
        formData.append('action', 'get_checkout_upsells');
        formData.append('nonce', checkoutUpsells.nonce);

        const response = await fetch(checkoutUpsells.ajax_url, {
            method: 'POST',
            body: formData
        });

        const data = await response.json();

        if (data.success && data.data.upsells) {
            displayUpsells(orderAddContainer, data.data.upsells);
        } else {
            console.log('No upsells available');
        }

    } catch (error) {
        console.error('Error loading upsells:', error);
    }
}

const displayUpsells = (container, upsells) => {
    if (upsells.length === 0) {
        container.remove();
        return;
    }
    const upsellHtmlWrapper = document.createElement('div');
    upsellHtmlWrapper.classList.add('checkout-upsells');
    upsellHtmlWrapper.setAttribute('id', 'pe-order-add');

    UPSELL_TITLE = UPSELL_TITLE ? UPSELL_TITLE : container.textContent;

    upsellHtmlWrapper.innerHTML = `
            <h3>${UPSELL_TITLE}</h3>
            <div class="upsell-products">
                ${upsells.map(productHtml => productHtml)}
            </div>
    `;

    container.replaceWith(upsellHtmlWrapper);
    initEvents();
}


function initEvents() {
    const crossSells = document.querySelectorAll('.upsell-products .pe-side-cart__item--cross-sell');
    if (crossSells.length > 0) {
        crossSells.forEach(variationSelect => {
            const addCrossSell = variationSelect.querySelector('.pe-side-cart--add-cross-sell');
            const selectCrossSellVariant = variationSelect.querySelector('.pe-side-cart__variations > select');

            if (addCrossSell) {
                addCrossSell.addEventListener('click', async (e) => {
                    event.preventDefault();
                    variationSelect.classList.add('loading');
                    const productId = addCrossSell.dataset.productId;
                    const discountType = addCrossSell.dataset.discountType;

                    if (discountType && discountType !== 'none') {
                        const fd = new FormData();
                        fd.append('action', 'pe_add_cross_sell');
                        fd.append('nonce', window.peCrossSell?.nonce);
                        fd.append('product_id', productId);
                        fd.append('discount_type', discountType);
                        fd.append('discount_value', addCrossSell.dataset.discountValue);
                        const res = await fetch(window.peCrossSell?.ajax_url, {method: 'POST', body: fd});
                        const data = await res.json();
                        if (!data.success) {
                            console.error('pe_add_cross_sell error:', data);
                        }
                        window.location.reload();
                    } else {
                        const nonce = checkoutUpsells.store_nonce;
                        await fetch('/wp-json/wc/store/v1/cart/add-item', {
                            method: 'POST',
                            headers: {'Content-Type': 'application/json', 'Nonce': nonce},
                            body: JSON.stringify({id: parseInt(productId, 10), quantity: 1}),
                        });
                        initiateCheckoutAction();
                    }
                })
            }

            if (selectCrossSellVariant) {
                selectCrossSellVariant.addEventListener('change', (e) => {
                    const productId = selectCrossSellVariant.value;
                    addCrossSell.dataset.productId = productId;
                    addCrossSell.removeAttribute('disabled');
                });
            }
        });
    }
}

const addUpsellToCart = async (e) => {
    const button = e.target;
    const productId = button.dataset.productId;

    button.disabled = true;
    button.textContent = 'Adding...';

    try {
        const response = await fetch('/wp-json/wc/store/v1/cart/add-item', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Nonce': wc.wcSettings.nonce
            },
            body: JSON.stringify({
                id: productId,
                quantity: 1
            })
        });

        if (response.ok) {
            button.textContent = 'Added!';
            button.classList.add('added');
            setTimeout(() => {
                button.closest('.upsell-product').style.opacity = '0.5';
            }, 500);
        } else {
            throw new Error('Failed to add product');
        }

    } catch (error) {
        console.error('Error adding to cart:', error);
        button.textContent = 'Try Again';
        button.disabled = false;
    }
}